import React, { useState, useEffect } from "react";
import styles from "./PrefectureSelect.module.css";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faMap } from "@fortawesome/free-solid-svg-icons";

const PrefectureSelect = ({
  onPrefectureSelect,
  activePrefecture,
  onMapChange,
}) => {
  const [prefectures, setPrefectures] = useState([]);
  const [areas, setAreas] = useState([]);
  const [filter, setFilter] = useState({
    prefecture: [],
    area: false,
  });
  const { t } = useTranslation();

  useEffect(() => {
    setPrefectures([
      { name: t("北海道"), area: t("北海道・東北") },
      { name: t("青森県"), area: t("北海道・東北") },
      { name: t("岩手県"), area: t("北海道・東北") },
      { name: t("宮城県"), area: t("北海道・東北") },
      { name: t("秋田県"), area: t("北海道・東北") },
      { name: t("山形県"), area: t("北海道・東北") },
      { name: t("福島県"), area: t("北海道・東北") },
      { name: t("東京都"), area: t("関東") },
      { name: t("千葉県"), area: t("関東") },
      { name: t("埼玉県"), area: t("関東") },
      { name: t("神奈川県"), area: t("関東") },
      { name: t("茨城県"), area: t("関東") },
      { name: t("栃木県"), area: t("関東") },
      { name: t("群馬県"), area: t("関東") },
      { name: t("新潟県"), area: t("中部") },
      { name: t("富山県"), area: t("中部") },
      { name: t("石川県"), area: t("中部") },
      { name: t("福井県"), area: t("中部") },
      { name: t("山梨県"), area: t("中部") },
      { name: t("長野県"), area: t("中部") },
      { name: t("岐阜県"), area: t("中部") },
      { name: t("静岡県"), area: t("中部") },
      { name: t("愛知県"), area: t("中部") },
      { name: t("三重県"), area: t("中部") },
      { name: t("滋賀県"), area: t("近畿") },
      { name: t("京都府"), area: t("近畿") },
      { name: t("大阪府"), area: t("近畿") },
      { name: t("兵庫県"), area: t("近畿") },
      { name: t("奈良県"), area: t("近畿") },
      { name: t("和歌山県"), area: t("近畿") },
      { name: t("鳥取県"), area: t("中国") },
      { name: t("島根県"), area: t("中国") },
      { name: t("岡山県"), area: t("中国") },
      { name: t("広島県"), area: t("中国") },
      { name: t("山口県"), area: t("中国") },
      { name: t("徳島県"), area: t("四国") },
      { name: t("香川県"), area: t("四国") },
      { name: t("愛媛県"), area: t("四国") },
      { name: t("高知県"), area: t("四国") },
      { name: t("福岡県"), area: t("九州・沖縄") },
      { name: t("佐賀県"), area: t("九州・沖縄") },
      { name: t("長崎県"), area: t("九州・沖縄") },
      { name: t("熊本県"), area: t("九州・沖縄") },
      { name: t("大分県"), area: t("九州・沖縄") },
      { name: t("宮崎県"), area: t("九州・沖縄") },
      { name: t("鹿児島県"), area: t("九州・沖縄") },
      { name: t("沖縄県"), area: t("九州・沖縄") },
    ]);
    setAreas([
      { name: t("北海道・東北") },
      { name: t("関東") },
      { name: t("中部") },
      { name: t("近畿") },
      { name: t("中国") },
      { name: t("四国") },
      { name: t("九州・沖縄") },
    ]);
  }, [t]);

  const handleFilterChange = (key, value) => {
    if (key === "area" && value === false) {
      // エリアをリセットした場合、エリアと都道府県をリセット
      setFilter({ prefecture: [], area: false });
      onPrefectureSelect([]);
    } else if (key === "area" && value === filter.area) {
      // 同じエリアを選択した場合、何もしない
      setFilter((prev) => ({ ...prev, [key]: value }));
    } else if (key === "area" && value !== filter.area) {
      // 異なるエリアを選択した場合、エリアを変更し、都道府県をリセット
      setFilter((prev) => ({ ...prev, [key]: value, prefecture: [] }));
      const prefs = prefectures.filter((prefecture) => {
        return prefecture.area === value;
      });
      onPrefectureSelect(prefs.map((pref) => pref.name));
    } else if (key === "prefecture" && value === filter.prefecture) {
      // 同じ都道府県を選択した場合、何もしない
      setFilter({ prefecture: [], area: filter.area });
      const prefs = prefectures.filter((prefecture) => {
        return prefecture.area === filter.area;
      });
      onPrefectureSelect(prefs.map((pref) => pref.name));
    } else {
      // 異なる都道府県を選択した場合、都道府県を変更
      setFilter((prev) => ({ ...prev, [key]: value }));
      if (key === "prefecture") {
        onPrefectureSelect([value]);
      }
    }
  };

  const handleMapChange = () => {
    setFilter({ prefecture: [], area: false });
    onPrefectureSelect([]);
    onMapChange();
  };

  const filteredPrefectures = prefectures.filter((prefecture) => {
    return prefecture.area === filter.area;
  });

  return (
    <div className={styles.PrefectureSelect}>
      <div className={styles.wrapper}>
        <div className={styles.areaPanel}>
          <button
            aria-label="地図を表示"
            onClick={() => handleMapChange()}
            className={styles.toggleMapButton}
          >
            <FontAwesomeIcon icon={faMap} /> 地図から探す
          </button>
          {areas.map((area, index) => (
            <button
              key={index}
              onClick={() => handleFilterChange("area", area.name)}
              className={
                filter.area === area.name ? styles.active : styles.inactive
              }
            >
              {t(area.name)}
            </button>
          ))}
        </div>
        <div
          className={styles.prefecturePanel}
          style={{ display: filter.area ? "block" : "none" }}
        >
          {filteredPrefectures.map((prefecture, index) => (
            <button
              key={index}
              onClick={() => handleFilterChange("prefecture", prefecture.name)}
              className={`${
                filter.prefecture === prefecture.name
                  ? styles.active
                  : styles.default
              } ${
                activePrefecture.has(t(prefecture.name))
                  ? styles.have
                  : styles.notHave
              }`}
            >
              {t(prefecture.name)}
            </button>
          ))}
        </div>
        <div
          style={{ display: filter.area ? "block" : "none" }}
          className={styles.clearButton}
          onClick={() => handleFilterChange("area", false)}
        >
          <FontAwesomeIcon icon={faXmark} />
        </div>
      </div>
    </div>
  );
};

export default PrefectureSelect;
